module.exports = __webpack_public_path__ + "static/media/Assets-07-Camden-Market-01.9c0ef269.png";